export default "__VITE_ASSET__d4c74718__"